import React from "react";

import SVGLogo from "@components/atoms/Icon/svg/logo.svg?react";

function FooterLogo() {
  return (
    <div className="col-span-2 mb-5 pc:col-span-1">
      <SVGLogo className="mb-2.5" fill="currentColor" />
      <p className="w-1/2 text-sm font-normal leading-normal pc:w-60">
        Copyright © {new Date().getFullYear()} TUNE. All rights reserved.
        <br />
        All content on this website, including but not limited to text, graphics, logos, images, and software, is the
        property of TUNE and any unauthorized use of these materials, including reproduction is strictly prohibited
        without the prior written consent of TUNE.
      </p>
    </div>
  );
}

export default FooterLogo;
